import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // console.log('[EXIT] connect', { timestamp: new Date().toISOString() })
    // Inicializar estado
    this.isTransitionOut = false
    this.overlayInstantElement = null

    // Verificar flag al conectar
    const connectFlag = sessionStorage.getItem('news_exit_transition_active')

    this.setupTurboListeners()
    // Asegurarse de que el scroll restoration manual esté activo
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
  }

  disconnect() {
    // console.log('[EXIT] disconnect', { timestamp: new Date().toISOString() })
    this.removeTurboListeners()
    this.removeOverlay()
  }

  // setupTurboListeners() {
  //   console.log('[EXIT] setupTurboListeners', { timestamp: new Date().toISOString() })
  setupTurboListeners() {
    this.turboLoadHandler = this.handleLoad.bind(this)
    this.transitionOutHandler = this.handleTransitionOut.bind(this)
    document.addEventListener("turbo:load", this.turboLoadHandler)
    document.addEventListener("transition-out", this.transitionOutHandler)
    // console.log('[EXIT] listeners registrados', { timestamp: new Date().toISOString() })
  }

  removeTurboListeners() {
    // console.log('[EXIT] removeTurboListeners', { timestamp: new Date().toISOString() })
    document.removeEventListener("turbo:load", this.turboLoadHandler)
    document.removeEventListener("transition-out", this.transitionOutHandler)
  }

  handleTransitionOut(event) {
    // Prevenir procesamiento duplicado

    // Prevenir procesamiento duplicado si ya estamos en transición
    if (this.isTransitionOut) {
      return
    }

    // Marcar que es una transición de salida
    this.isTransitionOut = true

    // Marcar en sessionStorage que es una transición de salida
    sessionStorage.setItem('news_exit_transition_active', 'true')

    // Limpiar cualquier estado de transición de entrada
    sessionStorage.removeItem('news_enter_transition_active')

    // Eliminar cualquier overlay/loader residual de entrada - limpieza agresiva
    const cleanupSelectors = [
      '.news-enter-transition-overlay',
      '.news-enter-transition-reveal',
      '.news-enter-transition-loader',
      '.news-enter-transition-rect-blue',
      '.news-enter-transition-rect-white',
      '[id^="enter-overlay-"]',
      '[id^="loader-"]',
      '[id^="reveal-"]'
    ]
    cleanupSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => el.remove())
    })

    // Mostrar overlay instantáneo antes de navegar
    this.showOverlayInstant()
  }

  // Método para loggear todos los overlays/loaders en el DOM - desactivado
  logDomOverlays(context) {
    // Método desactivado - usado solo para debugging
  }

  handleLoad() {
    // Verificar si hay una transición de salida activa en sessionStorage
    const isExitTransitionActive = sessionStorage.getItem('news_exit_transition_active') === 'true'

    // Si es una transición de salida, mostrar animación de salida
    if (isExitTransitionActive) {
      // Destruir overlay instantáneo antes de mostrar la animación de salida
      this.removeOverlayInstant()
      // Mostrar animación de salida
      this.showExitAnimation()

      // Limpieza agresiva de cualquier elemento de entrada residual después de la animación
      setTimeout(() => {
        const cleanupSelectors = [
          '.news-enter-transition-overlay',
          '.news-enter-transition-reveal',
          '.news-enter-transition-loader',
          '.news-enter-transition-rect-blue',
          '.news-enter-transition-rect-white',
          '[id^="enter-overlay-"]',
          '[id^="loader-"]',
          '[id^="reveal-"]'
        ]
        cleanupSelectors.forEach(selector => {
          document.querySelectorAll(selector).forEach(el => el.remove())
        })
      }, 800) // Después de que la animación de salida termine (600ms + margen)
    }
    // Resetear flag de transición de salida
    this.isTransitionOut = false
  }

  showExitAnimation() {
    // Buscar el elemento header para calcular su altura
    const headerElement = document.querySelector('header')
    const headerHeight = headerElement ? headerElement.offsetHeight : 0

    // Crear overlay de salida (capa negra completa sin loader)
    const exitOverlay = document.createElement("div")
    exitOverlay.className = "news-exit-transition-overlay"
    exitOverlay.id = `exit-${Date.now()}`
    exitOverlay.style.cssText = `
      position: fixed;
      top: ${headerHeight}px;
      bottom: 0;
      left: 0;
      right: 0;
      height: calc(100vh - ${headerHeight}px);
      background: black;
      z-index: 40;
      clip-path: inset(0 0 0 0);
      transition: clip-path 600ms ease-out;
      pointer-events: none;
    `
    document.body.appendChild(exitOverlay)

    // Forzar reflow
    exitOverlay.offsetHeight

    // Animación de salida: descubrir contenido desde arriba hacia abajo usando clip-path
    setTimeout(() => {
      exitOverlay.style.clipPath = "inset(100% 0 0 0)"

      // Remover overlay después de la animación
      setTimeout(() => {
        exitOverlay.remove()
        // Limpiar el flag de sessionStorage después de que la animación de salida se complete
        sessionStorage.removeItem('news_exit_transition_active')
      }, 600)
    }, 100)
  }

  removeOverlay() {
    // Este método está aquí por compatibilidad, pero no hace nada
    // ya que el overlay se destruye automáticamente en showExitAnimation
  }

  showOverlayInstant() {
    // console.log('[EXIT] showOverlayInstant', { timestamp: new Date().toISOString() })
    if (this.overlayInstantElement) {
      // console.log('[EXIT] overlay instantáneo ya existe, retornando', { timestamp: new Date().toISOString() })
      return
    }

    // Verificar si close_article_controller ya creó el overlay
    const existingOverlay = document.querySelector('.close-article-instant-overlay')
    if (existingOverlay) {
      // console.log('[EXIT] overlay de close_article encontrado, usándolo', { timestamp: new Date().toISOString() })
      this.overlayInstantElement = existingOverlay
      return
    }

    // Buscar el elemento header para calcular su altura
    const headerElement = document.querySelector('header')
    const headerHeight = headerElement ? headerElement.offsetHeight : 0

    // Crear overlay instantáneo
    this.overlayInstantElement = document.createElement("div")
    this.overlayInstantElement.className = "news-exit-transition-instant"
    this.overlayInstantElement.style.cssText = `
      position: fixed;
      top: ${headerHeight}px;
      bottom: 0;
      left: 0;
      right: 0;
      height: calc(100vh - ${headerHeight}px);
      background: black;
      z-index: 40;
      pointer-events: none;
    `
    document.body.appendChild(this.overlayInstantElement)
    // console.log('[EXIT] overlay instantáneo creado', { timestamp: new Date().toISOString() })
  }

  removeOverlayInstant() {
    // console.log('[EXIT] removeOverlayInstant', { timestamp: new Date().toISOString() })
    if (this.overlayInstantElement) {
      this.overlayInstantElement.remove()
      this.overlayInstantElement = null
      // console.log('[EXIT] overlay instantáneo eliminado', { timestamp: new Date().toISOString() })
    }
  }
}
